import { WATCHLIST_MEMBERS_RETRIEVE_REQUEST, WATCHLIST_MEMBERS_RETRIEVED, WATCHLIST_MEMBERS_RETRIEVE_ERR, WATCHLIST_MEMBER_CREATE_REQUEST, WATCHLIST_MEMBER_CREATED, WATCHLIST_MEMBER_CREATE_ERR, WATCHLIST_MEMBER_DELETE_REQUEST, WATCHLIST_MEMBER_DELETED, WATCHLIST_MEMBER_DELETE_ERR, WATCHLIST_MEMBER_UPDATE_REQUEST, WATCHLIST_MEMBER_UPDATED, WATCHLIST_MEMBER_UPDATE_ERR } from '../actions/actionTypes';
import initialState from "./initialState";
import stateConfig from '../config/state';

function watchlistReducer(state = initialState.watchlist, action) {
  let status = stateConfig.responseStatus;

  switch (action.type) {
    case WATCHLIST_MEMBERS_RETRIEVE_REQUEST:
    case WATCHLIST_MEMBER_CREATE_REQUEST:
    case WATCHLIST_MEMBER_DELETE_REQUEST:
    case WATCHLIST_MEMBER_UPDATE_REQUEST:
      return { ...state, responseStatus: status.DEFAULT, responseErr: null, };
    case WATCHLIST_MEMBERS_RETRIEVED:
      return {
        ...state, 
        responseStatus: status.COMPLETE, 
        responseErr: null, 
        watchlistMembers: action.data
      };
    case WATCHLIST_MEMBER_CREATED:
      return { 
        ...state, 
        responseStatus: status.COMPLETE, 
        responseErr: null, 
        watchlistMembers: [...state.watchlistMembers, action.data]
      };
    case WATCHLIST_MEMBER_DELETED:
      return {
        ...state,
        responseStatus: status.COMPLETE,
        responseErr: null,
        watchlistMembers: state.watchlistMembers.filter(member => member._id !== action.objectId
      )};
    case WATCHLIST_MEMBER_UPDATED:
      return { 
        ...state, 
        responseStatus: status.COMPLETE, 
        responseErr: null, 
        watchlistMembers: state.watchlistMembers.map((member) => member._id === action.objectId ? action.data : member
      )};
    case WATCHLIST_MEMBERS_RETRIEVE_ERR:
    case WATCHLIST_MEMBER_CREATE_ERR:
    case WATCHLIST_MEMBER_DELETE_ERR:
    case WATCHLIST_MEMBER_UPDATE_ERR:
      return { ...state, responseStatus: status.ERROR, responseErr: action.error };
    default:
      return state;
  }
}

export default watchlistReducer;